import React, { useState, useEffect } from 'react';
import { FileText, Upload, Loader2, Download, Trash2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { auth } from '../../utils/auth';
import { Surface } from '../calm';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * SourcesPanel - Document management for AI analysis
 */
const SourcesPanel = ({ caseId }) => {
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSources();
  }, [caseId]);

  const fetchSources = async () => {
    try {
      const token = auth.getToken();
      const response = await axios.get(
        `${API}/ai-workspace/sources/matter/${caseId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSources(response.data.sources || []);
    } catch (error) {
      console.error('Failed to fetch sources:', error);
      toast.error('Kunne ikke laste dokumenter');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="w-8 h-8 animate-spin text-ai-primary" />
      </div>
    );
  }

  return (
    <div className="p-6 space-y-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-text-primary mb-2">
            Dokumenter for AI-analyse
          </h3>
          <p className="text-sm text-text-secondary">
            Disse dokumentene kan brukes som kilder for AI-agentene
          </p>
        </div>

        {sources.length === 0 ? (
          <Surface className="text-center py-12">
            <FileText className="w-12 h-12 mx-auto mb-4 text-text-secondary" />
            <h4 className="font-semibold text-text-primary mb-2">
              Ingen dokumenter
            </h4>
            <p className="text-sm text-text-secondary mb-4">
              Last opp dokumenter i Dokumenter-fanen for å bruke dem i AI-analyser
            </p>
          </Surface>
        ) : (
          <div className="space-y-2">
            {sources.map(source => (
              <Surface key={source.id} className="!p-4">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-lg bg-violet-100 flex items-center justify-center flex-shrink-0">
                    <FileText className="w-5 h-5 text-ai-primary" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-medium text-text-primary truncate">
                      {source.filename}
                    </h4>
                    <div className="flex items-center gap-3 mt-1">
                      {source.file_type && (
                        <span className="text-xs text-text-secondary">
                          {source.file_type.toUpperCase()}
                        </span>
                      )}
                      {source.file_size && (
                        <span className="text-xs text-text-secondary">
                          {(source.file_size / 1024).toFixed(1)} KB
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </Surface>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SourcesPanel;